import {Checkbox} from "components";
import {getName} from "helpers/string";
import ExpandableArrow from "mapx-components/ExpandableArrow";
import CheckboxList from "mapx-components/Inputs/CheckboxList";
import React from "react";
import {TCity, TContinent, TCountry, TRegion, TState} from "../types";
import CountryItem from "./CountryItem";

type ContinentItemProps = {
	continent: TContinent;
	expanded: Record<number, boolean>;
	disabled: boolean;
	shouldRenderCountryRegions: boolean;
	isSelected: boolean;
	isPartiallySelected: boolean;
	onToggle: () => void;
	onToggleExpand: () => void;
	toggleExpandItem: (item: TContinent | TCountry | TRegion | TState) => void;
	handleCountryChange: (countryId: number) => void;
	toggleRegion: (region: TRegion, country: TCountry) => void;
	toggleState: (state: TState, region: TRegion, country: TCountry) => void;
	toggleCity: (city: TCity, state: TState, region: TRegion, country: TCountry) => void;
	hasChildren: (item: TCountry | TRegion | TState) => boolean;
	isCountrySelected: (countryId: number) => boolean;
	isCountryPartiallySelected: (country: TCountry) => boolean;
	isRegionSelected: (regionId: number, countryId: number) => boolean;
	isRegionPartiallySelected: (region: TRegion, country: TCountry) => boolean;
	isStateSelected: (stateId: number, regionId: number, countryId: number) => boolean;
	isStatePartiallySelected: (state: TState, region: TRegion, country: TCountry) => boolean;
	isCitySelected: (
		cityId: number,
		stateId: number,
		regionId: number,
		countryId: number,
	) => boolean;
};

const ContinentItem: React.FC<ContinentItemProps> = ({
	continent,
	expanded,
	disabled,
	shouldRenderCountryRegions,
	isSelected,
	isPartiallySelected,
	onToggle,
	onToggleExpand,
	toggleExpandItem,
	handleCountryChange,
	toggleRegion,
	toggleState,
	toggleCity,
	hasChildren,
	isCountrySelected,
	isCountryPartiallySelected,
	isRegionSelected,
	isRegionPartiallySelected,
	isStateSelected,
	isStatePartiallySelected,
	isCitySelected,
}) => {
	const {id: continentId, countries} = continent;

	return (
		<CheckboxList.Accordion key={continentId}>
			<CheckboxList.AccordionHeader>
				<ExpandableArrow onClick={onToggleExpand} rotated={!expanded[continentId]} />

				<Checkbox
					borderColor="#0C5850"
					isChecked={isSelected}
					key={continentId}
					label={`${getName(continent.name || String(continentId))} (${
						countries?.length || 0
					})`}
					onChange={onToggle}
					value={String(continentId)}
					partiallySelected={isPartiallySelected}
					disabled={disabled}
				/>
			</CheckboxList.AccordionHeader>

			{countries?.map((country) => (
				<CountryItem
					key={country.id}
					country={country}
					continentId={continentId}
					expanded={expanded}
					disabled={disabled}
					shouldRenderCountryRegions={shouldRenderCountryRegions}
					isSelected={isCountrySelected(country.id)}
					isPartiallySelected={isCountryPartiallySelected(country)}
					hasChildren={hasChildren(country)}
					onToggle={() => handleCountryChange(country.id)}
					onToggleExpand={() => toggleExpandItem(country)}
					toggleExpandItem={toggleExpandItem}
					toggleRegion={toggleRegion}
					toggleState={toggleState}
					toggleCity={toggleCity}
					isRegionSelected={isRegionSelected}
					isRegionPartiallySelected={isRegionPartiallySelected}
					isStateSelected={isStateSelected}
					isStatePartiallySelected={isStatePartiallySelected}
					isCitySelected={isCitySelected}
				/>
			))}
		</CheckboxList.Accordion>
	);
};

export default ContinentItem;
